var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"payments",attrs:{"headers":_vm.headers,"items":_vm.payments,"hide-default-footer":"","disable-pagination":"","item-key":"invoicePaymentId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }